export default class PopupInfo {
  constructor(button, target) {
    this.$button = $(button);
    this.$target = $(target);

    this.$button.click(this.close.bind(this));
  }

  close(e) {
    try {
      this.setCookie(this.$target.data('id') + '__closed', true);
    } catch (error) {
      //
    }

    e.preventDefault();
    this.$target.addClass('popup-info--closed');

    setTimeout(() => {
      this.$target.remove();
    }, 1000);
  }

  setCookie(name, value, days) {
    let expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
}



// WEBPACK FOOTER //
// ./scripts/components/PopupInfo.js